module.exports = __webpack_public_path__ + "static/media/lenor_hut.fc35637f.webp";